<script lang="ts">
    import type { Snippet } from 'svelte';

    interface Props {
        children?: Snippet;
    }

    let { children }: Props = $props();
</script>

{#if children}
    <div class="reptile-product-header">
        {@render children()}
    </div>
{/if}

<style lang="scss">
    @use '@otto-ec/design-tokens/tokens';
    @use '@otto-ec/otto-components-utils/scss/mixins';

    .reptile-product-header {
        display: grid;
        grid-template-columns: 1fr;
        row-gap: tokens.$oc-semantic-spacing-absolute-25;
        align-items: center;

        /**
 *
 *
 *
 *
 *
 *
 */
        :global(.reptile-product-title),
        :global(.reptile-top-info) {
            /**
 *
 *
 *
 */
            min-width: 0;
        }

        /**
 *
 *
 */
        :global(> [data-secondary-action]) {
            margin-top: tokens.$oc-semantic-spacing-absolute-25;
        }

        @include mixins.breakpoint-from-l($containerFirst: true) {
            grid-template-columns: 1fr auto;

            :global(> [data-secondary-action]) {
                /*                                                                      */
                grid-column: 2;
                grid-row: 1;
                /**
 */
                margin-top: 0;
            }

            :global(.reptile-product-title),
            :global(.reptile-top-info) {
                /*                                                        */
                grid-column: 1 / -1;
            }
        }
    }
</style>
